import truckComponent  from './truck.component';
import truckCreate     from './create'
import truckEdit       from './edit'
import truckAll        from './all'

let truckModule = angular.module('truck', [
  truckCreate,
  truckEdit,
  truckAll
])

.component('truck', truckComponent)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('truck.edit', {
      url: '/edit/:id',
      component: 'truckedit'      
    })

    .state('truck.create', {
      url: '/create',
      component: 'truckcreate'
    })

    .state('truck.all', {
      url: '/all/:page',
      component: 'truckall'
    })
})
.name;

export default truckModule;


// WEBPACK FOOTER //
// ./client/app/components/truck/index.js